<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page_title" translate>{{'transition_1.page_title'}}</h1>

     <information outer-style="width:100%">
          <h2 translate>{{'transition_1.completed_list'}}</h2>

          <div class="service-item">
               <div class="service-confirm left-w4">
                    <img src="refresh/assets/images/confirm-blue.png" width="30" height="30"/>
               </div>
               <div class="service-text right-w91">
                   <strong translate='transition_1.register_birth.title' class="service-title"></strong>
                   <div   translate='transition_1.register_birth.description' class="service-body"></div>
               </div>
          </div>   

          <h2 translate>{{'transition_1.next_you_can.title'}}</h2>

          <div [hidden]="!noException()">
               <div class="service-item">
                    <div class="service-confirm left-w5">
                         <img src="assets/images/confirm.png"/>
                    </div>
                    <div class="service-text right-w91">
                        <strong translate='transition_1.next_you_can.order_birth_certificate.title' class="service-title"></strong>
                        <div  translate='transition_1.next_you_can.order_birth_certificate.description' class="service-body"></div>
                    </div>
               </div>                 
               <div class="service-item">
                    <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                    <div class="service-text right-w91">
                        <strong translate='transition_1.next_you_can.additional_services.title' class="service-title"></strong>
                        <div translate='transition_1.next_you_can.additional_services.description' class="service-body"></div>
                    </div>
               </div>  
          </div>

          <div [hidden]="!(aboutChild.isChildDeceased == 'Y')">
               <div>
                    <div class="service-item">
                         <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                         <div class="service-text right-w91">
                             <strong translate='transition_1.next_you_can.order_birth_certificate.title' class="service-title"></strong>
                         </div>
                    </div>  
                    <div class="service-item">
                         <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                         <div class="service-text right-w91">
                             <strong translate='transition_1.next_you_can.additional_services.title' class="service-title"></strong>
                             <div translate='transition_1.next_you_can.additional_services.child_deceased_desc' class="service-body"></div>
                         </div>
                    </div>  
               </div>   
          </div>

          <div [hidden]="!(eligibility.isCustodyOtherThanParent == 'Y')">
               <div class="service-item">
                    <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                    <div class="service-text right-w91">
                        <strong translate='transition_1.next_you_can.order_birth_certificate.title' class="service-title"></strong>
                        <div translate='transition_1.next_you_can.order_birth_certificate.description' class="service-body"></div>
                    </div>
               </div>  
          </div>
     </information>

     <div class="btn-div">
          <div><button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
     </div>

     <div class="flex-center accord-body">
          <accordion header="transition_1.accordion.header" translate>
               <div class="accordion-padding-inner" translate>{{'transition_1.accordion.content1'}}</div>
               <div class="accordion-padding-inner" translate>{{'transition_1.accordion.content2'}}</div>
               <div class="accordion-padding-inner" [innerHTML]="'transition_1.accordion.content3' | translate"></div>
          </accordion>
     </div>
     <br/>
</div>



